import dynamic from 'next/dynamic'

export { default as TitleSection } from './title-section'
export { default as SummarySection } from './summary-section'
export { default as AccountSection } from './account-section'
export { FormCard } from '@/features/Register/elements'
export { default as AccountSectionView } from './account-section-view'
export { default as useActivePlan } from './use-active-plan'
export {
  usePaymentForm,
  default as PaymentFormProvider
} from './payment-form-provider'
export {
  useAccountForm,
  default as AccountFormProvider
} from './account-form-provider'

export const BillingSection = dynamic(() => import('./billing-section'))
